import Flexer from 'js/components/Flexer/Flexer'
import type { SiteStoreState } from 'js/lib/stores/SiteStore'

import type { EventItemViewFragment } from '../EventPage/EventItemView.fragment.generated'

import AddToCalendar from './components/AddToCalendar'
import ViewQrCode from './components/ViewQrCode'
import ViewTicketLink from './components/ViewTicketLink'
import styles from './EventActions.module.css'

type Props = {
    site: SiteStoreState['site']
    entity: EventItemViewFragment
}

const EventActions = ({ site, entity }: Props) => {
    const { ticketLink, qrAccess, isAttending } = entity

    return (
        <Flexer
            className={styles.wrapper}
            gutter={false}
            divider
            dividerOffset="lg"
        >
            {ticketLink && <ViewTicketLink ticketLink={entity.ticketLink} />}

            {qrAccess && isAttending === 'accept' && (
                <ViewQrCode guid={entity.guid} />
            )}

            <AddToCalendar site={site} entity={entity} />
        </Flexer>
    )
}

export default EventActions
